// Auto-generated normalizer for table: ModuloContenido
export function moduloContenidoNormalize(row) {
  return {
    idModuloContenido: row.idModuloContenido ?? row.IdModuloContenido ?? row.id ?? row.Id ?? 0,
    idModulo: row.idModulo ?? row.IdModulo ?? 0,
    idAsociado: row.idAsociado ?? row.IdAsociado ?? 0,
    tablaContenido: row.tablaContenido ?? row.TablaContenido ?? '',
    activo: row.activo ?? row.Activo ?? false,
    orden: row.orden ?? row.Orden ?? 0,
  };
}
